// This file is auto-generated by @hey-api/openapi-ts

import type { CancelablePromise } from './core/CancelablePromise';
import { OpenAPI } from './core/OpenAPI';
import { request as __request } from './core/request';
import type { AdminUserLoginAccessTokenData, AdminUserLoginAccessTokenResponse, AdminUserReadUserMeResponse, AppleSubscriptionListAppleSubscriptionsData, AppleSubscriptionListAppleSubscriptionsResponse, AppleSubscriptionGetAppleSubscriptionData, AppleSubscriptionGetAppleSubscriptionResponse, AppleSubscriptionDeleteAppleSubscriptionData, AppleSubscriptionDeleteAppleSubscriptionResponse, AppleSubscriptionListApplicationAppleSubscriptionsData, AppleSubscriptionListApplicationAppleSubscriptionsResponse, AppleSubscriptionListApplicationNotificationLogsData, AppleSubscriptionListApplicationNotificationLogsResponse, AppleSubscriptionListSubscriptionDispatchLogsData, AppleSubscriptionListSubscriptionDispatchLogsResponse, AppleSubscriptionListSubscriptionClientEventLogsData, AppleSubscriptionListSubscriptionClientEventLogsResponse, AppleSubscriptionListGlobalSubscriptionTraceTimelinesData, AppleSubscriptionListGlobalSubscriptionTraceTimelinesResponse, AppleSubscriptionListSubscriptionTraceTimelinesData, AppleSubscriptionListSubscriptionTraceTimelinesResponse, AppleSubscriptionRetrySubscriptionDispatchLogsData, AppleSubscriptionRetrySubscriptionDispatchLogsResponse, ApplicationCreateApplicationData, ApplicationCreateApplicationResponse, ApplicationListApplicationsData, ApplicationListApplicationsResponse, ApplicationGetApplicationData, ApplicationGetApplicationResponse, ApplicationUpdateApplicationData, ApplicationUpdateApplicationResponse, ApplicationDeleteApplicationData, ApplicationDeleteApplicationResponse, ApplicationUpdateAppleConfigData, ApplicationUpdateAppleConfigResponse, ApplicationUpdateAppleEnvironmentData, ApplicationUpdateAppleEnvironmentResponse, ApplicationListAppleNotificationMockPresetsResponse, ApplicationGetAppleNotifyEndpointData, ApplicationGetAppleNotifyEndpointResponse, ApplicationMockAppleNotificationData, ApplicationMockAppleNotificationResponse, ApplicationVerifyAppleNotifyEndpointData, ApplicationVerifyAppleNotifyEndpointResponse, ApplicationTestProxyConnectivityData, ApplicationTestProxyConnectivityResponse, ApplicationTestAppleCredentialsData, ApplicationTestAppleCredentialsResponse, ApplicationTestAppsflyerCredentialsData, ApplicationTestAppsflyerCredentialsResponse, ApplicationTestTbaCredentialsData, ApplicationTestTbaCredentialsResponse, ProxyServiceCreateProxyServiceData, ProxyServiceCreateProxyServiceResponse, ProxyServiceListProxyServicesData, ProxyServiceListProxyServicesResponse, ProxyServiceGetProxyServiceData, ProxyServiceGetProxyServiceResponse, ProxyServiceUpdateProxyServiceData, ProxyServiceUpdateProxyServiceResponse, ProxyServiceDeleteProxyServiceData, ProxyServiceDeleteProxyServiceResponse, ProxyServiceTestProxyServiceConnectivityData, ProxyServiceTestProxyServiceConnectivityResponse } from './types.gen';

export class AdminUserService {
    /**
     * 登录获取访问令牌
     * OAuth2 compatible token login, get an access token for future requests
     * @param data The data for the request.
     * @param data.formData
     * @returns Token Successful Response
     * @throws ApiError
     */
    public static loginAccessToken(data: AdminUserLoginAccessTokenData): CancelablePromise<AdminUserLoginAccessTokenResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/login/access-token',
            formData: data.formData,
            mediaType: 'application/x-www-form-urlencoded',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * 获取当前用户信息
     * Get current user.
     * @returns UserPublic Successful Response
     * @throws ApiError
     */
    public static readUserMe(): CancelablePromise<AdminUserReadUserMeResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/users/me'
        });
    }
}

export class AppleSubscriptionService {
    /**
     * 获取Apple订阅列表
     * @param data The data for the request.
     * @param data.skip
     * @param data.limit
     * @returns AppleSubscriptionList Successful Response
     * @throws ApiError
     */
    public static listAppleSubscriptions(data: AppleSubscriptionListAppleSubscriptionsData = {}): CancelablePromise<AppleSubscriptionListAppleSubscriptionsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/apple-subscriptions',
            query: {
                skip: data.skip,
                limit: data.limit
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * 获取Apple订阅详情
     * @param data The data for the request.
     * @param data.subscriptionId
     * @returns AppleSubscriptionPublic Successful Response
     * @throws ApiError
     */
    public static getAppleSubscription(data: AppleSubscriptionGetAppleSubscriptionData): CancelablePromise<AppleSubscriptionGetAppleSubscriptionResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/apple-subscriptions/{subscription_id}',
            path: {
                subscription_id: data.subscriptionId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * 删除Apple订阅
     * @param data The data for the request.
     * @param data.subscriptionId
     * @returns void Successful Response
     * @throws ApiError
     */
    public static deleteAppleSubscription(data: AppleSubscriptionDeleteAppleSubscriptionData): CancelablePromise<AppleSubscriptionDeleteAppleSubscriptionResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/apple-subscriptions/{subscription_id}',
            path: {
                subscription_id: data.subscriptionId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * 获取应用的Apple订阅列表
     * @param data The data for the request.
     * @param data.applicationId
     * @returns AppleSubscriptionList Successful Response
     * @throws ApiError
     */
    public static listApplicationAppleSubscriptions(data: AppleSubscriptionListApplicationAppleSubscriptionsData): CancelablePromise<AppleSubscriptionListApplicationAppleSubscriptionsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/applications/{application_id}/apple-subscriptions',
            path: {
                application_id: data.applicationId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * 获取应用的Apple通知日志
     * @param data The data for the request.
     * @param data.applicationId
     * @param data.skip
     * @param data.limit
     * @returns AppleNotificationLogPublic Successful Response
     * @throws ApiError
     */
    public static listApplicationNotificationLogs(data: AppleSubscriptionListApplicationNotificationLogsData): CancelablePromise<AppleSubscriptionListApplicationNotificationLogsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/applications/{application_id}/apple-notification-logs',
            path: {
                application_id: data.applicationId
            },
            query: {
                skip: data.skip,
                limit: data.limit
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * 获取应用订阅事件回传日志
     * @param data The data for the request.
     * @param data.applicationId
     * @param data.channel
     * @param data.skip
     * @param data.limit
     * @returns SubscriptionEventDispatchLogPublic Successful Response
     * @throws ApiError
     */
    public static listSubscriptionDispatchLogs(data: AppleSubscriptionListSubscriptionDispatchLogsData): CancelablePromise<AppleSubscriptionListSubscriptionDispatchLogsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/applications/{application_id}/subscription-dispatch-logs',
            path: {
                application_id: data.applicationId
            },
            query: {
                channel: data.channel,
                skip: data.skip,
                limit: data.limit
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * 获取应用客户端订阅入口事件日志
     * @param data The data for the request.
     * @param data.applicationId
     * @param data.skip
     * @param data.limit
     * @returns SubscriptionClientEventLogPublic Successful Response
     * @throws ApiError
     */
    public static listSubscriptionClientEventLogs(data: AppleSubscriptionListSubscriptionClientEventLogsData): CancelablePromise<AppleSubscriptionListSubscriptionClientEventLogsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/applications/{application_id}/subscription-client-event-logs',
            path: {
                application_id: data.applicationId
            },
            query: {
                skip: data.skip,
                limit: data.limit
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * 全局搜索订阅跨链路时间线视图
     * @param data The data for the request.
     * @param data.originalTransactionId
     * @param data.notificationUuid
     * @param data.uid
     * @param data.limit
     * @returns SubscriptionLifecycleTracePublic Successful Response
     * @throws ApiError
     */
    public static listGlobalSubscriptionTraceTimelines(data: AppleSubscriptionListGlobalSubscriptionTraceTimelinesData = {}): CancelablePromise<AppleSubscriptionListGlobalSubscriptionTraceTimelinesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/subscription-trace-timelines',
            query: {
                original_transaction_id: data.originalTransactionId,
                notification_uuid: data.notificationUuid,
                uid: data.uid,
                limit: data.limit
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * 获取应用订阅跨链路时间线视图
     * @param data The data for the request.
     * @param data.applicationId
     * @param data.originalTransactionId
     * @param data.notificationUuid
     * @param data.uid
     * @param data.limit
     * @returns SubscriptionLifecycleTracePublic Successful Response
     * @throws ApiError
     */
    public static listSubscriptionTraceTimelines(data: AppleSubscriptionListSubscriptionTraceTimelinesData): CancelablePromise<AppleSubscriptionListSubscriptionTraceTimelinesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/applications/{application_id}/subscription-trace-timelines',
            path: {
                application_id: data.applicationId
            },
            query: {
                original_transaction_id: data.originalTransactionId,
                notification_uuid: data.notificationUuid,
                uid: data.uid,
                limit: data.limit
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * 重试应用订阅事件回传
     * @param data The data for the request.
     * @param data.applicationId
     * @param data.requestBody
     * @returns SubscriptionDispatchRetryResult Successful Response
     * @throws ApiError
     */
    public static retrySubscriptionDispatchLogs(data: AppleSubscriptionRetrySubscriptionDispatchLogsData): CancelablePromise<AppleSubscriptionRetrySubscriptionDispatchLogsResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/applications/{application_id}/subscription-dispatch-logs/retry',
            path: {
                application_id: data.applicationId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
}

export class ApplicationService {
    /**
     * 创建应用
     * @param data The data for the request.
     * @param data.requestBody
     * @returns ApplicationPublic Successful Response
     * @throws ApiError
     */
    public static createApplication(data: ApplicationCreateApplicationData): CancelablePromise<ApplicationCreateApplicationResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/applications',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * 获取应用列表
     * @param data The data for the request.
     * @param data.skip
     * @param data.limit
     * @returns ApplicationList Successful Response
     * @throws ApiError
     */
    public static listApplications(data: ApplicationListApplicationsData = {}): CancelablePromise<ApplicationListApplicationsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/applications',
            query: {
                skip: data.skip,
                limit: data.limit
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * 获取应用详情
     * @param data The data for the request.
     * @param data.applicationId
     * @returns ApplicationDetail Successful Response
     * @throws ApiError
     */
    public static getApplication(data: ApplicationGetApplicationData): CancelablePromise<ApplicationGetApplicationResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/applications/{application_id}',
            path: {
                application_id: data.applicationId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * 更新应用
     * @param data The data for the request.
     * @param data.applicationId
     * @param data.requestBody
     * @returns ApplicationPublic Successful Response
     * @throws ApiError
     */
    public static updateApplication(data: ApplicationUpdateApplicationData): CancelablePromise<ApplicationUpdateApplicationResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v1/applications/{application_id}',
            path: {
                application_id: data.applicationId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * 删除应用
     * @param data The data for the request.
     * @param data.applicationId
     * @returns void Successful Response
     * @throws ApiError
     */
    public static deleteApplication(data: ApplicationDeleteApplicationData): CancelablePromise<ApplicationDeleteApplicationResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/applications/{application_id}',
            path: {
                application_id: data.applicationId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * 更新Apple订阅配置
     * @param data The data for the request.
     * @param data.applicationId
     * @param data.requestBody
     * @returns ApplicationPublic Successful Response
     * @throws ApiError
     */
    public static updateAppleConfig(data: ApplicationUpdateAppleConfigData): CancelablePromise<ApplicationUpdateAppleConfigResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/applications/{application_id}/apple-config',
            path: {
                application_id: data.applicationId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * 切换应用 Apple 环境（Sandbox/Production）
     * @param data The data for the request.
     * @param data.applicationId
     * @param data.requestBody
     * @returns ApplicationPublic Successful Response
     * @throws ApiError
     */
    public static updateAppleEnvironment(data: ApplicationUpdateAppleEnvironmentData): CancelablePromise<ApplicationUpdateAppleEnvironmentResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v1/applications/{application_id}/apple-environment',
            path: {
                application_id: data.applicationId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * 获取 App Store 通知模拟预设
     * @returns AppleNotificationMockPreset Successful Response
     * @throws ApiError
     */
    public static listAppleNotificationMockPresets(): CancelablePromise<ApplicationListAppleNotificationMockPresetsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/apple-notification-mock-presets'
        });
    }
    
    /**
     * 获取应用推荐的 Apple notify 回调地址
     * @param data The data for the request.
     * @param data.applicationId
     * @returns ApplicationNotifyEndpointPublic Successful Response
     * @throws ApiError
     */
    public static getAppleNotifyEndpoint(data: ApplicationGetAppleNotifyEndpointData): CancelablePromise<ApplicationGetAppleNotifyEndpointResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/applications/{application_id}/apple-notify-endpoint',
            path: {
                application_id: data.applicationId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * 模拟发送 App Store Server Notification
     * @param data The data for the request.
     * @param data.applicationId
     * @param data.requestBody
     * @returns AppleNotificationMockResult Successful Response
     * @throws ApiError
     */
    public static mockAppleNotification(data: ApplicationMockAppleNotificationData): CancelablePromise<ApplicationMockAppleNotificationResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/applications/{application_id}/apple-notifications/mock',
            path: {
                application_id: data.applicationId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * 验证应用 notify 地址是否可响应
     * @param data The data for the request.
     * @param data.applicationId
     * @param data.requestBody
     * @returns ApplicationNotifyVerifyResult Successful Response
     * @throws ApiError
     */
    public static verifyAppleNotifyEndpoint(data: ApplicationVerifyAppleNotifyEndpointData): CancelablePromise<ApplicationVerifyAppleNotifyEndpointResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/applications/{application_id}/apple-notify-endpoint/verify',
            path: {
                application_id: data.applicationId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * 测试 socks5 代理可用性（返回服务端IP与代理出口IP）
     * @param data The data for the request.
     * @param data.requestBody
     * @returns ProxyConnectivityTestResult Successful Response
     * @throws ApiError
     */
    public static testProxyConnectivity(data: ApplicationTestProxyConnectivityData): CancelablePromise<ApplicationTestProxyConnectivityResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/applications/credential-tests/proxy',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * 测试 Apple v2 凭证可用性
     * @param data The data for the request.
     * @param data.requestBody
     * @returns CredentialTestResult Successful Response
     * @throws ApiError
     */
    public static testAppleCredentials(data: ApplicationTestAppleCredentialsData): CancelablePromise<ApplicationTestAppleCredentialsResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/applications/credential-tests/apple',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * 测试 AppsFlyer 凭证可用性
     * @param data The data for the request.
     * @param data.requestBody
     * @returns CredentialTestResult Successful Response
     * @throws ApiError
     */
    public static testAppsflyerCredentials(data: ApplicationTestAppsflyerCredentialsData): CancelablePromise<ApplicationTestAppsflyerCredentialsResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/applications/credential-tests/appsflyer',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * 测试 TBA 凭证可用性
     * @param data The data for the request.
     * @param data.requestBody
     * @returns CredentialTestResult Successful Response
     * @throws ApiError
     */
    public static testTbaCredentials(data: ApplicationTestTbaCredentialsData): CancelablePromise<ApplicationTestTbaCredentialsResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/applications/credential-tests/tba',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
}

export class ProxyServiceService {
    /**
     * 创建代理服务
     * @param data The data for the request.
     * @param data.requestBody
     * @returns ProxyServicePublic Successful Response
     * @throws ApiError
     */
    public static createProxyService(data: ProxyServiceCreateProxyServiceData): CancelablePromise<ProxyServiceCreateProxyServiceResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/proxy-services',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * 获取代理服务列表
     * @param data The data for the request.
     * @param data.skip
     * @param data.limit
     * @returns ProxyServicePublic Successful Response
     * @throws ApiError
     */
    public static listProxyServices(data: ProxyServiceListProxyServicesData = {}): CancelablePromise<ProxyServiceListProxyServicesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/proxy-services',
            query: {
                skip: data.skip,
                limit: data.limit
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * 获取代理服务详情
     * @param data The data for the request.
     * @param data.proxyServiceId
     * @returns ProxyServicePublic Successful Response
     * @throws ApiError
     */
    public static getProxyService(data: ProxyServiceGetProxyServiceData): CancelablePromise<ProxyServiceGetProxyServiceResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/proxy-services/{proxy_service_id}',
            path: {
                proxy_service_id: data.proxyServiceId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * 更新代理服务
     * @param data The data for the request.
     * @param data.proxyServiceId
     * @param data.requestBody
     * @returns ProxyServicePublic Successful Response
     * @throws ApiError
     */
    public static updateProxyService(data: ProxyServiceUpdateProxyServiceData): CancelablePromise<ProxyServiceUpdateProxyServiceResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v1/proxy-services/{proxy_service_id}',
            path: {
                proxy_service_id: data.proxyServiceId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * 删除代理服务
     * @param data The data for the request.
     * @param data.proxyServiceId
     * @returns void Successful Response
     * @throws ApiError
     */
    public static deleteProxyService(data: ProxyServiceDeleteProxyServiceData): CancelablePromise<ProxyServiceDeleteProxyServiceResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/proxy-services/{proxy_service_id}',
            path: {
                proxy_service_id: data.proxyServiceId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * 测试代理服务是否可达
     * @param data The data for the request.
     * @param data.proxyServiceId
     * @param data.requestBody
     * @returns ProxyServiceConnectivityTestResult Successful Response
     * @throws ApiError
     */
    public static testProxyServiceConnectivity(data: ProxyServiceTestProxyServiceConnectivityData): CancelablePromise<ProxyServiceTestProxyServiceConnectivityResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/proxy-services/{proxy_service_id}/connectivity-test',
            path: {
                proxy_service_id: data.proxyServiceId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
}